var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgFullMatchIcon = function SvgFullMatchIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1v14h16V1zm15 13H1V2h14zM14 3H2v10h12zM7 8H6v1H5v1H4V9h1V8h1V7H5V6H4V5h1v1h1v1h1zm4 2H8V9h3z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFullMatchIcon);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;